import React from 'react'
import Helmet from 'react-helmet'
import { helmetJsonLdProp } from 'react-schemaorg'
import { Thing, WithContext } from 'schema-dts'

// Source: https://github.com/google/react-schemaorg/blob/master/src/json-ld.tsx#L20
interface JsonLdOptions {
  /** Adds indentation, white space, and line break characters to JSON-LD output. {@link JSON.stringify} */
  space?: string | number
}

interface Props<T extends Thing> extends JsonLdOptions {
  item: WithContext<T>
}

// Clone of https://github.com/google/react-schemaorg#plain-react-usage
const JsonLd = <T extends Thing>({ item, ...options }: Props<T>) => (
  <Helmet script={[helmetJsonLdProp<T>(item, options)]} />
)

export default JsonLd
